import { getUserId } from '@nw/shared/data-access';

import stores from '../../../../data-access/src/stores';

export interface UserDetailsType {
  userId: string;
  browserSessionId: string;
}
export function getUserInfoDetails(): UserDetailsType {
  const {
    uiStore: { browserSessionId }
  } = stores;
  const userDetails = {
    userId: getUserId(),
    browserSessionId: browserSessionId
  };

  return userDetails;
}
